import { type Enum } from '@webapp/infrastructure/types/Enum'

export const CardTypes = {
  PHYSICAL: 0,
  VIRTUAL: 1,
} as const

export type CardTypeEnum = Enum<typeof CardTypes>
